module.exports = __webpack_public_path__ + "fonts/PT_Sans-CaptionBold.9ac67d44.eot";